import { FlashIcon } from './FlashIcon';

/**
 * author: Google
 * id EF3D6923-793B-410C-B349-90A6A338F06C
 * name flash
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/flash.svg
 * tags
 * - Weather 
 */
export const ElectricityIcon = FlashIcon;
export default ElectricityIcon